import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
/**
 * Tabmenu element, used to wrap tabmenu-item elements
 *
 * @slot - Unnamed slot (default)
 *
 */
let SDBNavTabMenu = class SDBNavTabMenu extends LitElement {
    render() {
        return html `
            <div class="tabWrapper">
                <ul id="tabUl">
                    <slot></slot>
                </ul>
            </div>
        `;
    }
};
SDBNavTabMenu.styles = [
    elements,
    css `
            :host {
                display: inline-flex;
                justify-content: flex-start;
            }

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    width: auto;
                }
            }

            #tabUl {
                list-style-type: none;
                margin: 0;
                padding: 0;
                overflow: hidden;
                background: transparent;
                font-weight: 400;
                letter-spacing: 0.5px;
                width: auto;
                float: left;
            }
        `,
];
SDBNavTabMenu = __decorate([
    customElement('sdb-nav-tabmenu')
], SDBNavTabMenu);
export { SDBNavTabMenu };
//# sourceMappingURL=sdb-nav-tabmenu.js.map